import React from 'react';

const ProjectDetailRow = ({ label, description }) => {
    return (
        <tr>
            <td>
                <div className="user-profile d-flex flex-row align-items-center">
                    <div className="user-detail">
                        <h5 className="user-name">{label} </h5>
                    </div>
                </div>
            </td>
            <td className="text-right">
                <div>{description}</div>
            </td>
        </tr>

    );
};


export default ProjectDetailRow;



// WEBPACK FOOTER //
// ./components/Agile/project/projectDetail/projectDetailRow/index.js